import { App } from 'vue'

import ZScrollButtons from '@/plugins/app@components/scroll-buttons/z-scroll-buttons.vue'
import ZScrollOverlay from '@/plugins/app@components/scroll-overlay/z-scroll-overlay.vue'
import ZListHeader from '@/plugins/app@components/list-header/z-list-header.vue'
import ZIconButton from '@/plugins/refactor/components/icon-button/z-icon-button.vue'

export default (app: App) => {
	app.component('Z-scroll-buttons', ZScrollButtons)
	app.component('Z-scroll-overlay', ZScrollOverlay)
	app.component('Z-list-header', ZListHeader)
	app.component('Z-icon-button', ZIconButton)
}
